import PropTypes from "prop-types";
import styles from "./BadgeSection.module.css";
import AddNoteIcon from "./Images/Add_Note.svg";
import NoteIcon from "./Images/Note_Icon.svg";
import PinIcon from "./Images/Pin_Icon.svg";
import ShareIcon from "./Images/Share_Icon.svg";

function BadgeSection({
  hasBadge,
  pinLevel,
  badgeImageUrl,
  hasNote,
  showActionPill,
  showShare,
  onNoteClick,
  onAddNoteClick,
  onEditClick,
  onShareClick,
}) {
  const showEmptyState = !hasBadge;
  const showPinIcon = hasBadge;
  const showPill = hasBadge && !hasNote && showActionPill;
  const onPinClick = hasNote ? onNoteClick : onAddNoteClick;

  return (
    <div className={styles.wrapper}>
      <div
        className={`${styles.container} ${
          showPill
            ? showShare
              ? styles.containerPillWithShare
              : styles.containerPill
            : ""
        }`}
      >
        <div className={styles.content}>
          {hasBadge ? (
            badgeImageUrl ? (
              <img
                src={badgeImageUrl}
                alt={pinLevel ? `${pinLevel} badge` : "Current badge"}
                className={styles.badgeImage}
              />
            ) : (
              <div className={styles.badgeFallback}>
                {pinLevel || "Current Badge"}
              </div>
            )
          ) : (
            <div className={styles.emptyText}>No Current Badges...</div>
          )}
        </div>
      </div>

      {showPinIcon ? (
        <button
          type="button"
          className={styles.imageIconButton}
          onClick={onPinClick}
          aria-label={hasNote ? "View badge note" : "Add badge note"}
        >
          <img src={PinIcon} alt="" className={styles.noteIcon} />
        </button>
      ) : null}

      {showEmptyState ? (
        <button
          type="button"
          className={styles.imageIconButton}
          onClick={onAddNoteClick}
          aria-label="Add badge note"
        >
          <img src={AddNoteIcon} alt="" className={styles.addIcon} />
        </button>
      ) : null}

      {showPill ? (
        <div
          className={`${styles.iconPill} ${
            showShare ? styles.iconPillWide : ""
          }`}
        >
          <button
            type="button"
            className={styles.pillIconButton}
            onClick={onEditClick}
            aria-label="Edit badge note"
          >
            <img src={NoteIcon} alt="" className={styles.pillIcon} />
          </button>
          <button
            type="button"
            className={styles.pillTextButton}
            onClick={onEditClick}
            aria-label="Add badge note"
          >
            Add
          </button>
          {showShare ? (
            <button
              type="button"
              className={styles.pillIconButton}
              onClick={onShareClick}
              aria-label="Share badge note"
            >
              <img src={ShareIcon} alt="" className={styles.pillIcon} />
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

BadgeSection.propTypes = {
  hasBadge: PropTypes.bool,
  pinLevel: PropTypes.string,
  badgeImageUrl: PropTypes.string,
  hasNote: PropTypes.bool,
  showActionPill: PropTypes.bool,
  showShare: PropTypes.bool,
  onNoteClick: PropTypes.func,
  onAddNoteClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onShareClick: PropTypes.func,
};

BadgeSection.defaultProps = {
  hasBadge: false,
  pinLevel: "",
  badgeImageUrl: "",
  hasNote: false,
  showActionPill: false,
  showShare: false,
  onNoteClick: () => {},
  onAddNoteClick: () => {},
  onEditClick: () => {},
  onShareClick: () => {},
};

export default BadgeSection;
